<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AppItem',
})
</script>
<template>
    <div class="app-item" @click="handleClick">
      <!-- 图标部分（复用之前的AppIcon组件） -->
      <div class="imgApp">
        <AppIcon 
          :icon-key="iconKey" 
          :size="150" 
        />
      </div>
      
      <!-- 文字部分 -->
      <p 
        class="modname"  
        wrap 
        :title="sysName"
      >
        {{ menuName }}                
      </p>
    </div>
  </template>
  
  <script lang="ts" setup name="AppItem">
  import { defineProps, defineEmits } from 'vue';
  import AppIcon from './AppIcon.vue'; // 导入图标组件
  
  // 定义组件接收的属性
  const props = defineProps({
    // 图标标识（用于AppIcon组件）
    iconKey: {
      type: String,
      default: ''
    },
    // 应用名称（显示的文字）
    menuName: {
      type: String,
      required: true,
      default: ''
    },
    // 应用全称（鼠标悬停时显示的完整标题）
    sysName: {
      type: String,
      default: ''
    },
    // 点击所需的路径参数
    path: {
      type: String,
      required: true
    },
    // 菜单编码
    menuCode: {
      type: String,
      required: true
    },
    // 父菜单编码
    parentCode: {
      type: String,
      required: true
    }
  });
  
  // 定义触发的事件（将点击参数传递给父组件）
  const emit = defineEmits({
    'item-click': (path: string, menuName: string, menuCode: string, fullPath: string) => true
  });
  
  // 处理点击事件
  const handleClick = () => {
    emit('item-click', props.path, props.menuName, props.menuCode, props.path);
  };
  </script>
  
  <style scoped lang="less">
  .app-item {
    /* 确保点击区域覆盖整个应用项 */
    width: 100%;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
  
  /* 应用项悬停效果（整体上浮） */
  .app-item:hover {
    transform: translateY(-10px);
  }
  
  /* 图标容器样式 */
  .imgApp {
    margin: 0 auto;
    width: 150px;
    height: 150px;
  }
  
  /* 应用名称样式 */
  .modname {
    padding-top: 20px;
    font-size: 19px;
    letter-spacing: 3px;
    font-weight: 550;
    color: #555;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 190px;
    user-select: none;
    position: relative;
    z-index: 10;
    transition: color 0.2s ease;
    margin: 0; /* 清除默认margin */
  }
/* 图标悬停时icon颜色变化 */
:deep(.ant-avatar:hover .anticon) {
  color: #6bafff;
}  
  
  /* 文字悬停颜色变化 */
  .modname:hover {
    color: #3367d6 !important;
    }
    /* 图标内部icon基础样式（补充） */
  :deep(.ant-avatar .anticon) {
    font-size: 70px;
    color: #5a8fff;
    transition: color 0.2s ease;
    }

  :deep(.ant-avatar) {
  background-color: #e5f3ff !important; /* 淡蓝色背景 */
  border-radius: 40px !important; /* 圆角效果，关键修复 */
  overflow: hidden;
  }

:deep(.ant-avatar)::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 30%; /* 覆盖左上半部分宽度 */
  height: 70%; /* 覆盖左上半部分高度 */
  border-top: 1px solid rgba(255, 255, 255); /* 上边框（白色描边） */
  border-left: 1px solid rgba(255, 255, 255); /* 左边框（白色描边） */
  border-radius: 40px 0 0 0; /* 与图标圆角匹配，避免错位 */
  pointer-events: none; /* 不影响图标点击交互 */
  z-index: 2; /* 确保描边在图标之上 */
}
:deep(.ant-avatar)::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  width: 70%; /* 覆盖右下半部分宽度 */
  height: 30%; /* 覆盖右下半部分高度 */
  border-right: 1px solid rgba(255, 255, 255); /* 右边框（白色描边） */
  border-bottom: 1px solid rgb(255, 255, 255); /* 下边框（白色描边） */
  border-radius: 0 0 40px 0; /* 与图标圆角匹配 */
  pointer-events: none;
  z-index: 2;
}

:deep(.ant-avatar:hover::before),
:deep(.ant-avatar:hover::after) {
  border-color: rgba(209, 209, 209, 0.2); /* 描边颜色加深 */
  transition: border-color 0.2s ease;
}
  </style>
  